import { Uuid } from '@belimo-retrofit-portal/logic';
import { FormController } from '@form-ts/core';
import { Project } from 'src/modules/common/types/Project';
import { ProjectRole } from 'src/modules/common/types/ProjectRole';
import { FormError } from 'src/modules/form/types/FormError';
import { SharedUser } from 'src/modules/sharing-projects/types/SharedUser';
import { ShareProjectForm } from 'src/modules/sharing-projects/types/ShareProjectForm';
import { ShareProjectReloadData } from 'src/modules/sharing-projects/types/ShareProjectReloadData';
import { OrganizationUser } from 'src/modules/users/types/OrganizationUser';
import { createActions } from 'src/utils/createActions';
import { createTrigger } from 'src/utils/createTrigger';

export const SHARE_PROJECT_OPEN = createTrigger<Project>('SHARE_PROJECT_OPEN');
export const SHARE_PROJECT_CLOSE = createTrigger<void>('SHARE_PROJECT_CLOSE');

export const SHARE_PROJECT_FETCH = createActions<void, {
  sharedUsers: ReadonlyArray<SharedUser>;
  organizationUsers: ReadonlyArray<OrganizationUser>;
}, Project>('SHARE_PROJECT_FETCH');
export const SHARE_PROJECT_SUBMIT = createActions<
FormController<ShareProjectForm, FormError>,
ReadonlyArray<SharedUser>
>('SHARE_PROJECT_SUBMIT');

export const SHARE_PROJECT_REMOVE_OPEN = createTrigger<SharedUser>('SHARE_PROJECT_REMOVE_OPEN');
export const SHARE_PROJECT_REMOVE_CLOSE = createTrigger<void>('SHARE_PROJECT_REMOVE_CLOSE');
export const SHARE_PROJECT_REMOVE_SUBMIT = createActions<
void,
ReadonlyArray<SharedUser>
>('SHARE_PROJECT_REMOVE_SUBMIT');

export const SHARE_PROJECT_CHANGE_ROLE = createActions<
{ userId: Uuid; role: ProjectRole },
{ userId: Uuid; role: ProjectRole }
>('SHARE_PROJECT_CHANGE_ROLE');

export const SHARE_PROJECT_CHANGE_OWN_ROLE_OPEN = createTrigger<
{ user: SharedUser; role: ProjectRole }
>('SHARE_PROJECT_CHANGE_OWN_ROLE_OPEN');
export const SHARE_PROJECT_CHANGE_OWN_ROLE_CLOSE = createTrigger<void>('SHARE_PROJECT_CHANGE_OWN_ROLE_CLOSE');
export const SHARE_PROJECT_CHANGE_OWN_ROLE_SUBMIT = createActions<
{ user: SharedUser; role: ProjectRole },
{ user: SharedUser; role: ProjectRole }
>('SHARE_PROJECT_CHANGE_OWN_ROLE_SUBMIT');

export const SHARE_PROJECT_CHANGE_OWNER_OPEN = createTrigger<SharedUser>('SHARE_PROJECT_CHANGE_OWNER_OPEN');
export const SHARE_PROJECT_CHANGE_OWNER_CLOSE = createTrigger<void>('SHARE_PROJECT_CHANGE_OWNER_CLOSE');
export const SHARE_PROJECT_CHANGE_OWNER_SUBMIT = createActions<SharedUser, void>('SHARE_PROJECT_CHANGE_OWNER_SUBMIT');

export const SHARE_PROJECT_COPY_LINK = createTrigger<void>('SHARE_PROJECT_COPY_LINK');

export const SHARE_PROJECT_RELOAD_DATA = createTrigger<ShareProjectReloadData>('SHARE_PROJECT_RELOAD_DATA');
